module.exports = __webpack_public_path__ + "img/1024.040edd13.svg";